import React from 'react';
import {AutoField} from 'components/forms/fields';
import {Typography, Grid} from '@material-ui/core';
import vesselFields from './fields';
import cg719sFields from './cg719sFields';
import {bootstrapOldForm} from '../AutoSection';
import {PSingleLine} from 'components/TypographyShortcuts';
import {useFieldData} from '../hooks';
import {useContext} from 'react';
import {FormState} from '../context';
import VesselEndSection from './VesselEndSection';
import {LockableAutoField} from '../fields/AutoField';

const TonnageAndType = props => {
    const {node} = useContext(FormState);
    const isCg719s = node === 'cg719s' || node === 'generate_cg719s';
    const fields = isCg719s ? cg719sFields : vesselFields;
    const {schema, initialValues} = bootstrapOldForm(
        'Tonnage and Type',
        fields
    );
    const [vesselType, setVesselType] = useFieldData('vessel_type');
    const shouldSave = vesselType !== 'Offshore Installation';

    const [origin] = useFieldData('origin');
    const isPsix = origin === 'psix';
    const [tonnage] = useFieldData('tonnage');
    const [tonnageType] = useFieldData('tonnage_type');
    const [lengthTonnage] = useFieldData('length_tonnage');

    return (
        <VesselEndSection
            {...props}
            {...{schema, initialValues}}
            shouldSave={shouldSave}
        >
            {' '}
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant='h6' align='left'>
                        Tonnage and Type
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <PSingleLine>
                        Please provide the vessel's Tonnage, Tonnage Type, and
                        Length.
                        {isCg719s
                            ? "If vessel's tonnage is not available, please enter Length, Width, and Depth."
                            : null}
                    </PSingleLine>
                </Grid>
                <Grid item xs={12}>
                    <LockableAutoField
                        locked={isPsix}
                        field={fields.tonnage}
                        name='tonnage'
                        value={tonnage}
                    />
                </Grid>
                <Grid item xs={12}>
                    <LockableAutoField
                        locked={isPsix}
                        field={fields.tonnage_type}
                        name='tonnage_type'
                        value={tonnageType}
                    />
                </Grid>
                <Grid item xs={12}>
                    <LockableAutoField
                        locked={isPsix}
                        field={fields.length_tonnage}
                        name='length_tonnage'
                        value={lengthTonnage}
                    />
                </Grid>
                {['width_tonnage', 'depth_tonnage']?.map(field => (
                    <Grid item xs={12}>
                        <AutoField
                            field={fields[field]}
                            name={field}
                            key={field}
                        />
                    </Grid>
                ))}
                <Grid item xs={12}>
                    <AutoField
                        field={fields.vessel_type}
                        name='vessel_type'
                        key='vessel_type'
                        onChange={e => setVesselType(e.target.value)}
                    />
                </Grid>
                {(vesselType === 'Tank Ship' ||
                    vesselType === 'Tank Barge') && (
                    <Grid item xs={12}>
                        <AutoField
                            field={fields.tankship_or_barge_type}
                            name='tankship_or_barge_type'
                        />
                    </Grid>
                )}
                {['engine_horsepower', 'engine_mode_of_propulsion']?.map(
                    field => (
                        <Grid item xs={12}>
                            <AutoField
                                field={fields[field]}
                                name={field}
                                key={field}
                            />
                        </Grid>
                    )
                )}
                {props.children}
            </Grid>
        </VesselEndSection>
    );
};

export default TonnageAndType;
